<template>
  <tr class="plc-tableRow">
    <td data-th="Height" class="plc-tableRow__cell">
      <router-link :to="{ name: 'Block', params: { id: row.height } }" class="text-link">
        {{ row.height }}
      </router-link>
    </td>
    <td data-th="Date" class="plc-tableRow__cell">
      <span class="text text--white">{{ date() }}</span>
      <span class="text text--light"> {{ ' ' + time() }}</span>
    </td>
    <td data-th="Transactions" class="plc-tableRow__cell">
      <span class="plc-tableRow__txCount">{{ row.tx.length || 'n/a' }}</span>
      <gl-transaction-icon
        v-for="icon in icons()"
        :key="icon"
        :type="icon"
        class="plc-tableRow__txIcon"
      />
    </td>
    <td data-th="Total sent" class="plc-tableRow__cell text text--green">
      <span class="text text--green text--bold">{{ coinsSent() }} PLC</span>
    </td>
    <td data-th="Block size" class="plc-tableRow__cell text text--light">
      <span class="text text--light">{{ row.size || 'n/a' }}</span>
    </td>
  </tr>
</template>

<script>
import GlTransactionIcon from '@gl/GlTransactionIcon'
import { format } from 'date-fns'

export default {
  name: 'BlocksHistoryRow',
  components: { GlTransactionIcon },
  props: {
    row: {
      type: Object,
      required: true,
    },
  },
  methods: {
    date() {
      return this.row.time ? format(+new Date(this.row.time), 'yyyy.MM.dd') : 'n/a'
    },
    time() {
      return this.row.time ? format(+new Date(this.row.time), 'HH:mm:ss') : ''
    },
    coinsSent() {
      return this.row.tx.reduce((a, b) => a + b.outputsValue, 0) / 100000000
    },
    icons() {
      const types = this.row.tx.map(i => i.type)
      return [...new Set(types)].sort()
    },
  },
}
</script>

<style lang="scss" scoped>
@import '~styles/blocks/tableRow';

.badgeHidden {
  visibility: hidden;
}
</style>
